import React, { Suspense, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';
import { withSnackbar } from 'notistack';

import { connect } from '../../api/ws';
import styles from './styles';
import { useAppContext } from '~/application-context';

function Presentation({ route, history, enqueueSnackbar }) {
  const classes = styles();
  const appContext = useAppContext();

  useEffect(() => {
    connect({
      enqueueSnackbar,
      apiBaseURL: appContext.apiBaseURL,
    }).catch(() => {
      history.push('/auth/login');
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appContext.apiBaseURL]);

  return (
    <div className={classes.root}>
      <Suspense fallback={<LinearProgress />}>
        {renderRoutes(route.routes)}
      </Suspense>
    </div>
  );
}

Presentation.propTypes = {
  route: PropTypes.shape({}),
};

Presentation.defaultProps = {
  route: {},
};

export default withSnackbar(Presentation);
